<script setup>
/**
 * Temporary migration wrapper for standalone <q-skeleton /> usages that haven't yet been
 * replaced by a component's own `pending` prop or HrP for text.
 *
 * @status prefer-alternative
 * @group status-feedback
 * @useInstead HrSkeleton
 * @maturity deprecated
 * @deprecated Replace with the appropriate primitive's `pending` prop or HrP.
 */
defineOptions({ name: 'HrLegacySkeleton', inheritAttrs: false });
</script>

<template>
  <q-skeleton v-bind="$attrs" />
</template>
